import { GatewayTicketNote } from "@conformite/gateway";
import {
  Button,
  Card,
  FormField,
  FormGrid,
  FormRow,
} from "@endya-conformite/ui-kit";
import ChevronDown from "@endya-conformite/ui-kit/src/assets/icons/chevron-down.svg?react";
import ChevronUp from "@endya-conformite/ui-kit/src/assets/icons/chevron-up.svg?react";
import { replaceNBSP } from "@src/helper/clean.helper";
import { format, parseISO } from "date-fns";
import * as locale from "date-fns/locale";
import { useState } from "react";
import styles from "./ControleQuinquennalTicketNotes.module.scss";

type ControleQuinquennalTicketNoteProps = {
  note: GatewayTicketNote.TicketNote;
  defaultOpen: boolean;
};

export function ControleQuinquennalTicketNote({
  defaultOpen,
  note,
}: ControleQuinquennalTicketNoteProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  // Extract the axe name from the content format: "[Nom de l'axe] content"
  const contentMatch = note.content.match(/^\[([^\]]+)]\s*(.*)/s);
  const actualContent = contentMatch?.[2] || note.content;
  const withoutNBSP = replaceNBSP(actualContent).replace(
    "⚠️ NE PAS MODIFIER - COMMENTAIRE ADHERENT",
    ""
  );

  return (
    <FormRow>
      <FormField>
        <FormRow>
          <FormField>
            <div
              className={styles.header}
              onClick={() => setIsOpen((old) => !old)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") setIsOpen((old) => !old);
              }}
            >
              <p className={styles.titleContainer}>
                <span>
                  {format(parseISO(note.createdAt), "dd MMMM yyyy 'à' HH:mm", {
                    locale: locale.fr,
                  })}
                </span>
              </p>
              <Button
                variant="text"
                icon={isOpen ? <ChevronUp /> : <ChevronDown />}
              />
            </div>
          </FormField>
        </FormRow>
        {isOpen && (
          <FormRow className={styles.noteText}>
            <FormField>
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: withoutNBSP }}
              />
            </FormField>
          </FormRow>
        )}
      </FormField>
    </FormRow>
  );
}

type ControleQuinquennalTicketNotesProps = {
  notes: GatewayTicketNote.TicketNote[];
  axeLabel: string;
};

export function ControleQuinquennalTicketNotes({
  notes,
  axeLabel,
}: ControleQuinquennalTicketNotesProps) {
  // Filter notes for the current axe and sort by date (most recent first)
  const axeNotes = notes
    .filter((note) => note.content.startsWith(`[${axeLabel}]`))
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );

  if (axeNotes.length === 0) {
    return null;
  }

  return (
    <Card className={styles.container}>
      <FormGrid>
        <FormRow>
          <FormField>
            <h3 className={styles.title}>
              Commentaires de l&apos;adhérent ({axeNotes.length})
            </h3>
          </FormField>
        </FormRow>
        {axeNotes.map((note, index) => (
          <ControleQuinquennalTicketNote
            note={note}
            key={note.id}
            defaultOpen={index === 0}
          />
        ))}
      </FormGrid>
    </Card>
  );
}
